exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_defaultIconButton__1I_W4{width:2.25rem!important;height:2.25rem!important;padding:0!important}", ""]);

// exports
exports.locals = {
	"defaultIconButton": "style_defaultIconButton__1I_W4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/CopyToClipboardButton/style.less
// module id = 1784
// module chunks = 8